// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchPage .Paginator{margin-top:var(--vertical-space)}", "",{"version":3,"sources":["webpack://./a-portal/pages/SearchPage/index.sass"],"names":[],"mappings":"AACE,uBACE,gCAAA","sourcesContent":[".SearchPage\n  .Paginator\n    margin-top: var(--vertical-space)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
